import { IsArray, IsBoolean, IsOptional, IsString } from "class-validator";

export class DeviceDto {
  @IsString()
  matNr!: string;

  @IsString()
  name!: string;

  @IsBoolean()
  isAvailable!: boolean;

  @IsString()
  description!: string;

  @IsString()
  deviceType!: string;

  @IsString()
  piSheetURL!: string;

  @IsString()
  configurationURL!: string;

  @IsString()
  productImageCantoID!: string;

  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  countries?: string[];

  @IsOptional()
  @IsString()
  productFamily?: string;
}
